export function detectBrowser() {
    const userAgent = navigator.userAgent;
    if (/chrome|crios|crmo/i.test(userAgent) && !/edge|edg/i.test(userAgent)) return "Chrome";
    if (/safari/i.test(userAgent) && !/chrome|crios|crmo/i.test(userAgent)) return "Safari";
    if (/firefox|fxios/i.test(userAgent)) return "Firefox";
    if (/edg/i.test(userAgent)) return "Edge";
    if (/opr|opera/i.test(userAgent)) return "Opera";
    return "Chrome";
}

export function getAudioInstructions(browser) {
    const instructions = {
        Chrome: [
            // "Click the lock icon (🔒) in the address bar.",
            "Click the filter like icon in the address bar.",
            "Go to 'Site settings'.",
            "Find 'Sound' and set it to 'Allow'.",
        ],
        Safari: [
            "Go to 'Safari → Settings for This Website' (or Preferences → Websites tab).",
            "Under 'Auto-Play', select 'Allow All Auto-Play'.",
        ],
        Firefox: [
            "Click the lock icon (🔒) in the address bar.",
            "Go to 'Protection settings'.",
            "Or globally: Settings → Privacy & Security → Permissions → Autoplay → 'Allow Audio and Video'.",
        ],
        Edge: [
            "Click the lock icon (🔒) → Permissions for this site → Sound → Allow.",
            "Or globally: Settings → Cookies and site permissions → Media autoplay → Allow.",
        ],
        Opera: [
            "Click the lock icon → Site settings → Sound → Allow.",
        ],
        Unknown: [
            "Please check your browser's settings to allow sound/autoplay for this site.",
        ],
    };

    return instructions[browser] || instructions.Chrome;
}
